export default {
  COMPLETED: 'completed',
  REVERSED: 'reversed'
}
